export const PROJECT_ID = 'proxy-auth-component';
export const CONNECTION_ERROR = {
    CONNECTION_NOT_CONFIGURED: {
        message: 'The integration is not configured',
        description: 'Reach out to your administrator'
    },
    NETWORK_ERROR: {
        message: 'Connection Issue',
        description: 'The connection is temporarily unavailable. Please try again later or contact your administrator.'
    }
};
export const errorsByStatus = {
    403: {
        message: 'Access denied',
        description: 'You do not have access to this integration. Reach out to your administrator'
    },
    404: {
        message: 'Configuration is not found'
    },
    401: {
        message: 'Configuration mismatch',
        description: 'Micro app settings don’t match the authorization server'
    },
    500: {
        message: 'Something went wrong',
        description: 'Please try again later. If the issue persists contact your administrator'
    }
};
export const ThemeTypeNames = ['Light', 'Dark', 'Unknown'];
export const THEMES = {
    LIGHT: 'light',
    DARK: 'dark',
    UNKNOWN: 'unknown'
};
